import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import {
  getMeasurementById,
  getWasteTypes,
  getMealCategories,
  editMeasurement,
  exportMeasurementToCsv,
} from '../../services';

const ComponentFields = ({comp, i, update}) => {

  const [mealCategories, setMealCategories] = useState()
  const [wasteTypes, setWasteTypes] = useState()

  useEffect(() => {
    // Get meal categories
    getMealCategories().then(res => {
      const options = res.meal_categories.map((cat, i) => {
        return <option key={i} value={cat.id}>{cat.name}</option>
      })
      setMealCategories(options)
    })
    // Get waste types
    getWasteTypes().then(res => {
      const options = res.waste_types.map((type, i)=> {
        return <option key={i} value={type.id}>{type.name}</option>
      })
      setWasteTypes(options)
    })
  }, [])

  return (
    <div className="form__fields">
      <h4 style={{width:'100%', margin: '0px 20px'}}>Meting {i + 1}</h4>
      <div className="form__fields__field">
        <span className="form__fields__field__label">Gewicht in grammen</span>
        <input
          required="true"
          onChange={(e) => update(comp.id, 'weight', e.target.value)}
          type="text"
          className="form__fields__field__input"
          value={comp.weight}
        />
      </div>
      <div className="form__fields__field">
        <span className="form__fields__field__label">Dervingsreden</span>
        <select
          required="true"
          id="selectbox__location"
          onChange={(e) => update(comp.id, 'waste_type_id', e.target.value)}
          className="form__fields__field__input"
          value={comp.waste_type_id} >
          {wasteTypes}
        </select>
      </div>
      <div className="form__fields__field">
        <span className="form__fields__field__label">Maaltijdcategorie</span>
        <select
          required="true"
          id="selectbox__location"
          onChange={(e) => update(comp.id, 'meal_category_id', e.target.value)}
          className="form__fields__field__input"
          value={comp.meal_category_id} >
          {mealCategories}
        </select>
      </div>
      <div className="form__fields__field">
        <span className="form__fields__field__label">Opmerking</span>
        <input
          required="true"
          onChange={(e) => update(comp.id, 'note', e.target.value)}
          type="text"
          className="form__fields__field__input"
          value={comp.note}
        />
      </div>
    </div>
  )
}

const EditMeasurement = ({match}) => {
  // Function to update the data of meal_components based on their ID
  const updateComponent = (componentId, field, value) => {
    const comps = []
    components.map((comp, i) => {
      if(comp.id == componentId) {
        comp[field] = value
      }
      comps.push(comp)
    })
    console.log(comps)
    setComponents(comps)
  }

  // Function to send API request to update measurement
  const updateMeasurement = () => {
    editMeasurement(residentsPresent, components, employee, date, measurementId).then(() => {
      setRedirect(true);
    })
  }

  const downloadCsv = async () => {
    await exportMeasurementToCsv(measurementId);
  }

  const { measurementId } = match.params;
  const [components, setComponents] = useState()
  const [date, setDate] = useState('')
  const [editDate, setEditDate] = useState('')
  const [residentsPresent, setResidentsPresent] = useState('')
  const [department, setDepartment] = useState()
  const [redirect, setRedirect] = useState()
  const [employee, setEmployee] = useState('')
  const [departmentName, setDepartmentName] = useState('')
  const [locationName, setLocationName] = useState('')

  useEffect(() => {
    getMeasurementById(measurementId).then(res => {
      setComponents(res.measurement.components)
      setEditDate(new Date(res.measurement.date).toISOString().substr(0, 10))
      setResidentsPresent(res.measurement.residents_present)
      setDepartment(res.measurement.department_id)
      setEmployee(res.measurement.employee)
      setLocationName(res.measurement.location_name)
      setDepartmentName(res.measurement.department_name)
    })
  }, [])

  return (
    <div className="container">
      <h2 className="container__title">Registratie bewerken</h2>
      <div className="form__container">
        <div className="form__container__content">
          <div className="form__container__content__category">
            <span>Registratie</span>
          </div>
          <div className="form__fields">
            <div className="form__fields__field">
              <span className="form__fields__field__label">Medwerker</span>
              <input
                required={true}
                onChange={(e) => setEmployee(e.target.value)}
                type="text"
                className="form__fields__field__input"
                value={employee}
              />
            </div>
            <div className="form__fields__field">
              <span className="form__fields__field__label">Locatie</span>
              <input
                disabled={true}
                type="text"
                className="form__fields__field__input"
                value={locationName}
              />
            </div>
            <div className="form__fields__field">
              <span className="form__fields__field__label">Afdeling</span>
              <input
                disabled={true}
                type="text"
                className="form__fields__field__input"
                value={departmentName}
              />
            </div>
            <div className="form__fields__field">
              <span className="form__fields__field__label">Datum</span>
              <input
                required={true}
                onChange={(e) => setDate(e.target.value)}
                type="date"
                defaultValue={editDate}
                className="form__fields__field__input"
              />
            </div>
            <div className="form__fields__field">
              <span className="form__fields__field__label">Aanwezige bewoners</span>
              <input
                required={true}
                value={residentsPresent}
                onChange={(e) => setResidentsPresent(e.target.value)}
                type="text"
                className="form__fields__field__input"
              />
            </div>
          </div>
          <div className="form__container__content__category">
            <span>Metingen</span>
          </div>
          {components && components.map((comp, i) => {
            return <ComponentFields key={i} comp={comp} i={i} update={updateComponent}/>
          })}
          <button onClick={updateMeasurement} className="form__container__content__button">
            OPSLAAN <i className="fas fa-arrow-right"></i>
          </button>
          <button onClick={downloadCsv} className="form__container__content__button">
            Exporteer <i className="fas fa-download"></i>
          </button>
        </div>
      </div>
      {redirect && <Redirect to="/measurements" />}
    </div>
  )
}

export default EditMeasurement;
